<c-container class="mt-3">
  <c-row>
    <c-col>
      <h2>Payment Methods</h2>
    </c-col>
  </c-row>

  @if (isCrossGame) {
    <app-choose-your-game [message]="'Select a game to view payment methods'"
                          (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>
  }

  @if (game) {
    <c-row class="mb-3">
      <c-col>
        <mat-card>
          <mat-card-header>
            <mat-card-title>Filter Payment Methods</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="filterForm">
              <c-row>
                <c-col md="4">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Player Email</mat-label>
                    <input matInput formControlName="playerEmail" placeholder="Enter player email" data-testid="payment-methods-player-email-input">
                  </mat-form-field>
                </c-col>
                <c-col md="4">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Last 4 Digits</mat-label>
                    <input matInput formControlName="cardLastFourDigits" placeholder="Enter last 4 digits" maxlength="4" data-testid="payment-methods-last-four-digits-input">
                  </mat-form-field>
                </c-col>
                <c-col md="4">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Player ID</mat-label>
                    <input matInput formControlName="playerId" placeholder="Enter player ID" data-testid="payment-methods-player-id-input">
                  </mat-form-field>
                </c-col>
              </c-row>
              <c-row>
                <c-col md="4">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Payment Method ID</mat-label>
                    <input matInput formControlName="paymentMethodId" placeholder="Enter payment method ID" data-testid="payment-methods-payment-method-id-input">
                  </mat-form-field>
                </c-col>
                <c-col md="4">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Card Fingerprint</mat-label>
                    <input matInput formControlName="cardFingerprint" placeholder="Enter card fingerprint" data-testid="payment-methods-card-fingerprint-input">
                  </mat-form-field>
                </c-col>
              </c-row>
              <c-row>
                <c-col>
                  <button mat-raised-button color="primary" (click)="onSearchClick()" class="me-2" data-testid="payment-methods-search-button">
                    Search
                  </button>
                  <button mat-raised-button (click)="onResetClick()" data-testid="payment-methods-reset-button">
                    Reset
                  </button>
                </c-col>
              </c-row>
            </form>
          </mat-card-content>
        </mat-card>
      </c-col>
    </c-row>

    <c-row>
      <c-col>
        <mat-card>
          <mat-card-header>
            <mat-card-title>Payment Methods for {{ game.ShortName || game.Name }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ag-grid-angular
              class="ag-theme-quartz payment-methods-grid"
              [tooltipShowDelay]="0"
              domLayout='autoHeight'
              [rowHeight]="50"
              [pagination]="true"
              [paginationPageSize]="20"
              rowClass="table-row"
              [loading]="uiState === uiStateForTemplate.ShowLoading"
              (gridReady)="onGridReady($event)"
              overlayNoRowsTemplate="<span>No payment methods found</span>"
              [rowData]="paymentMethods"
              [columnDefs]="columnDefs">
            </ag-grid-angular>
          </mat-card-content>
        </mat-card>
      </c-col>
    </c-row>
  }
</c-container>
